import { createSelector } from '@reduxjs/toolkit';

import { sliceName } from './globalConfigConfig';
import { GlobalConfigState } from './globalConfigInterface';
import { ApplicationSDKState } from 'sdk/interfaces/sdkInterface';

const sliceSelector = (state: ApplicationSDKState) => {
    return state[sliceName];
};
export const baseUrlSelector = createSelector(sliceSelector, (slice: GlobalConfigState) => {
    return slice.baseUrl;
});
export const isSpinnerVisible = createSelector(sliceSelector, (slice: GlobalConfigState) => {
    return slice.isSpinnerVisible;
});
export const sessionAuthSelector = createSelector(sliceSelector, (slice: GlobalConfigState) => {
    return slice.auth;
});
export const authInfoSelector = createSelector(sliceSelector, (slice: GlobalConfigState) => {
    return slice.authInfo;
});
